import { render, staticRenderFns } from "./NgRateReport.vue?vue&type=template&id=cb6b6d2e&scoped=true&"
import script from "./NgRateReport.vue?vue&type=script&lang=js&"
export * from "./NgRateReport.vue?vue&type=script&lang=js&"
import style0 from "./NgRateReport.vue?vue&type=style&index=0&id=cb6b6d2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6b6d2e",
  null
  
)

export default component.exports